// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const MarkAsReviewed = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 3c1.53 0 2.925.573 3.984 1.515l-.709.709a5 5 0 1 0 .929 1.071l.72-.72A6 6 0 1 1 9 3"
    />
    <path stroke="currentColor" d="M6.5 8 9 10.5l8-8" />
  </svg>
);
const ForwardRef = forwardRef(MarkAsReviewed);
export default ForwardRef;
